<template>
  <div class="upload-content">
    <div class="clearfix mb-3">
      <div class="float-end d-flex">
        <!-- TODO: Change this button position beside McWizard -->
        <McButton
          class="upload-content__btn-next"
          :text="$t('global.next')"
          icon="icon-outline_arrow-right"
          iconPosition="right"
          :disabled="isDisableNextBtn"
          @click="handleProcessFile"
        />
      </div>
    </div>
    <b-card class="upload-card">
      <b-row>
        <b-col cols="4">
          <AttachmentField
            ref="attachment-field-ref"
            @update:isDisableNextBtn="isDisableNextBtn = $event"
          />
        </b-col>
        <b-col cols="8" class="d-flex">
          <GuideCard />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import AttachmentField from '../components/AttachmentField.vue'
import GuideCard from '../components/GuideCard.vue'

export default {
  components: {
    McButton,
    AttachmentField,
    GuideCard,
  },
  data() {
    return {
      isDisableNextBtn: true,
    }
  },
  methods: {
    handleProcessFile() {
      this.$refs['attachment-field-ref'].HandleProcessFile()
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-card {
  .card-body {
    padding: 24px;
  }
}
</style>
